import React from 'react';
import Link from 'next/link';
import { cn } from '@pickleballinc/ui/lib/utils';

interface NavItem {
	label: string;
	href?: string;
	isActive?: boolean;
	onClick?: () => void;
}

interface TeamNavbarProps {
	items: NavItem[];
	className?: string;
}

export const TeamNavbar = ({ items, className = '' }: TeamNavbarProps) => {
	return (
		<nav className={cn(`bg-gray-900 px-4 lg:px-6 ${className}`)}>
			<div className="overflow-x-auto scrollbar-hide">
				<div className="flex min-w-max">
					{items.map((item, index) => (
						<React.Fragment key={item.label}>
							<div
								className={cn(
									'px-6 text-2xl font-semibold cursor-pointer transition-colors duration-200 whitespace-nowrap text-white hover:bg-gray-800',
									{ 'hover:bg-transparent': item.isActive },
									{ 'bg-[#EF6820]': item.isActive }
								)}
								onClick={item.onClick}
							>
								{item.href ? (
									<Link href={item.href} className="block py-4">
										{item.label}
									</Link>
								) : (
									<span className="block py-4">{item.label}</span>
								)}
							</div>

							{index < items.length - 1 && !item.isActive && !items.at(index + 1)?.isActive && (
								<div className="flex items-center">
									<div className="w-[2px] bg-white h-12" />
								</div>
							)}
						</React.Fragment>
					))}
				</div>
			</div>
		</nav>
	);
};
